import { c as _c } from "react/compiler-runtime";
import { useDroppable } from '@dnd-kit/core';
import { IcoImages24 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
import type { SlotIndex } from './types';
type ComparisonSlotProps = {
  slot: SlotIndex;
  active: boolean;
  onActivate: () => void;
  children?: ReactNode;
};
const ComparisonSlot = t0 => {
  const $ = _c(18);
  const {
    slot,
    active,
    onActivate,
    children
  } = t0;
  const t1 = `slot:${slot}`;
  let t2;
  if ($[0] !== slot) {
    t2 = {
      slot
    };
    $[0] = slot;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      id: t1,
      data: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    setNodeRef,
    isOver
  } = useDroppable(t3);
  const t4 = `${slot === 0 ? "Left" : "Right"} comparison slot`;
  const t5 = isOver ? "outline-(--border-color-accent) bg-secondary" : active ? "outline-(--border-color-primary-hover)" : "outline-transparent";
  let t6;
  if ($[5] !== t5) {
    t6 = cx("m-0 min-w-0 border-0 p-0 rounded-lg outline-1 outline-offset-2", t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== active || $[8] !== children || $[9] !== onActivate || $[10] !== slot) {
    t7 = children ?? <button type="button" aria-label={`Select image for ${slot === 0 ? "left" : "right"} slot`} aria-pressed={active} onClick={onActivate} className="flex h-full min-h-72 w-full flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-tertiary bg-canvas text-caption-2 text-tertiary hover:bg-hover focus-visible:outline-accent"><IcoImages24 color="tertiary" />Choose image</button>;
    $[7] = active;
    $[8] = children;
    $[9] = onActivate;
    $[10] = slot;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onActivate || $[13] !== setNodeRef || $[14] !== t4 || $[15] !== t6 || $[16] !== t7) {
    t8 = <fieldset ref={setNodeRef} aria-label={t4} onPointerDownCapture={onActivate} onFocusCapture={onActivate} className={t6}>{t7}</fieldset>;
    $[12] = onActivate;
    $[13] = setNodeRef;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default ComparisonSlot;